import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import { Image } from "react-bootstrap";
const bg =
  "https://images.pexels.com/photos/297755/pexels-photo-297755.jpeg?cs=srgb&dl=adult-book-business-297755.jpg&fm=jpg";
export default class dstLogin extends Component {
  render() {
    return (
      <div className={css(styles.container)}>
        <Image
          className={css(styles.imagemtour)}
          src="https://firebasestorage.googleapis.com/v0/b/tourbrazil-41fbe.appspot.com/o/logo2.png?alt=media&token=c55d990d-a026-4353-bccd-0264bcf0ea23"
          responsive
        />
      </div>
    );
  }
}
const styles = StyleSheet.create({
  container: {
    "@media (max-width: 767px)": {
      height: "200px",
      paddingLeft: 0,
      paddingRight: 0
    },
    height: "97vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: `url("${bg}")`,
    backgroundSize: "cover"
  },
  bg: {
    position: "absolute",
    zIndex: "-1",
    width: "100%",
    height: "97vh"
  },
  col: {
    paddingLeft: 0,
    paddingRight: 0
  },
  imagemtour: {
    width: "80%",
    zIndex: "999"
  }
});



// WEBPACK FOOTER //
// ./src/assets/destaqueLogin/index.js